import { memo } from "react";

/**
 * Shared animated background layer for the customer-facing app.
 * Fixed behind all routes — orbs, rings, lines, and dots with subtle motion.
 */
function AmbientBackground() {
  return (
    <div className="ambient-bg" aria-hidden="true">
      <span className="ambient-orb ambient-orb-terra" />
      <span className="ambient-orb ambient-orb-sage" />
      <span className="ambient-orb ambient-orb-gold" />
      <span className="ambient-orb ambient-orb-terra ambient-orb-mid" />

      <span className="ambient-ring ambient-ring-one" />
      <span className="ambient-ring ambient-ring-two" />
      <span className="ambient-ring ambient-ring-three" />
      <span className="ambient-ring ambient-ring-four" />

      <svg className="ambient-wave ambient-wave-one" viewBox="0 0 1200 220" preserveAspectRatio="none">
        <path d="M-80 142C120 52 290 214 490 126C690 38 806 82 1010 132C1125 160 1214 108 1300 70" />
      </svg>
      <svg className="ambient-wave ambient-wave-two" viewBox="0 0 1200 220" preserveAspectRatio="none">
        <path d="M-100 84C78 154 248 34 444 94C626 150 784 194 976 88C1088 26 1190 48 1296 116" />
      </svg>
      <svg className="ambient-wave ambient-wave-three" viewBox="0 0 1200 180" preserveAspectRatio="none">
        <path d="M0 90 Q 300 20 600 95 T 1200 70" />
      </svg>

      <svg className="ambient-curve ambient-curve-left" viewBox="0 0 400 600" fill="none">
        <path d="M380 20 C 120 180, 80 420, 40 580" />
        <path d="M360 60 C 160 220, 120 400, 80 540" />
      </svg>
      <svg className="ambient-curve ambient-curve-right" viewBox="0 0 400 600" fill="none">
        <path d="M20 40 C 260 200, 300 380, 360 560" />
      </svg>

      <span className="ambient-stroke ambient-stroke-a" />
      <span className="ambient-stroke ambient-stroke-b" />
      <span className="ambient-stroke ambient-stroke-c" />

      <span className="ambient-dot ambient-dot-one" />
      <span className="ambient-dot ambient-dot-two" />
      <span className="ambient-dot ambient-dot-three" />
      <span className="ambient-dot ambient-dot-four" />
      <span className="ambient-dot ambient-dot-five" />
      <span className="ambient-dot ambient-dot-six" />

      <span className="ambient-cluster ambient-cluster-one" />
      <span className="ambient-cluster ambient-cluster-two" />
    </div>
  );
}

export default memo(AmbientBackground);
